<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yR3CBh/tc-custom/9780830853236.jpg?1696374748502" alt="This image is the cover for the book God Has Chosen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">God Has Chosen
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>"He chose us in Christ before the foundation of the world . . ."</strong> </p> <p>Among the traditional tenets of the Christian faith is the belief that God chooses or elects people for salvation. For some Christians, such an affirmation is an indication of God's sovereign and perfect will. For others, such a notion is troubling for it seems to downplay the significance of human agency and choice. Throughout the church's history, Christians have sought to understand the meaning of relevant biblical texts and debated this theological conundrum.</p> <p>With care and insight, theologian Mark Lindsay surveys the development of the Christian doctrine of election. After exploring Scripture on this theme, he turns to the various articulations of this doctrine from the early church fathers, including Augustine, and medieval theologians such as Aquinas, to John Calvin's view, the subsequent debate between Calvinists and Arminians, Karl Barth's modern reconception of the doctrine, and reflections on election in the shadow of the Holocaust.</p> <p>On this journey through the Bible and church history, readers will discover how Christians have understood the affirmation that God has chosen.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark R. Lindsay
      </h2>
      
      <p class="authorDescription body article"><p>Mark R. Lindsay (PhD, University of Western Australia) is Joan F. W. Munro Professor of Historical Theology at Trinity College Theological School at the University of Divinity in Melbourne, Australia. He is the author of <em>Reading Auschwitz with Barth</em>; <em>Barth, Israel and Jesus</em>; and <em>Covenanted Solidarity.</em> </p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?22138dc4